import React from "react";
import { useNavigate } from "react-router-dom";

import SearchPackage from "components/SearchPackage/SearchPackage";
import { Heading2 } from "widgets";
import { CreatePackageIcon, ProductOfferingIcon } from "shared/Icons";

import styles from "./HomePage.module.scss";

const handlePackageSelect = (package_group_id, navigate) => {
  navigate(`/packageDetails?packageGroupId=${package_group_id}`);
};
const handleOnclickCreatePackage = (navigate) => {
  navigate(`/createPackage`);
};
const handleCreateProductOfferings = (navigate) => {
  navigate(`/createProductOfferings`);
};
const handleOnclickUploadFeatureOfferings = (navigate) => {
  navigate(`/uploadFeatureOfferings`);
};
const handleOnclickUploadPackageSchedule = (navigate) => {
  navigate(`/uploadPackageSchedule`);
};
const handleOnclickUpdatePackageSchedule = (navigate) => {
  navigate(`/updatePackageSchedule`);
};
const handleOnclickUploadOrUpdatePackagePaymentHead = (navigate) => {
  navigate(`/uploadOrUpdatePackagePaymentHead`);
}

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.searchField}>
        <SearchPackage
          onPackageSelect={(pkg) =>
            handlePackageSelect(pkg.package_group_id, navigate)
          }
        />
      </div>
      <div className={styles.uploadContainer}>
        <div
          className={styles.card}
          onClick={() => handleOnclickCreatePackage(navigate)}
        >
          <>
            <CreatePackageIcon />
            <Heading2 heading="Create Packages" />
          </>
        </div>
        <div
          className={styles.card}
          onClick={() => handleCreateProductOfferings(navigate)}
        >
          <>
            <ProductOfferingIcon />
            <Heading2 heading="Create Product Offerings" />
          </>
        </div>
        <div
          className={styles.card}
          onClick={() => handleOnclickUploadFeatureOfferings(navigate)}
        >
          <>
            <CreatePackageIcon />
            <Heading2 heading="Upload Feature Offerings to Packages" />
          </>
        </div>
        <div
          className={styles.card}
          onClick={() => handleOnclickUploadPackageSchedule(navigate)}
        >
          <>
            <CreatePackageIcon />
            <Heading2 heading="Upload Package Schedule" />
          </>
        </div>
        <div
          className={styles.card}
          onClick={() => handleOnclickUpdatePackageSchedule(navigate)}
        >
          <>
            <CreatePackageIcon />
            <Heading2 heading="Update Package Schedule" />
          </>
        </div>
        <div
          className={styles.card}
          onClick={() => handleOnclickUploadOrUpdatePackagePaymentHead(navigate)}
        >
          <>
            <CreatePackageIcon />
            <Heading2 heading="Upload/Update Package Payment Head" />
          </>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
